import { render, staticRenderFns } from "./SocialWall.vue?vue&type=template&id=351c9539&scoped=true"
import script from "./SocialWall.vue?vue&type=script&lang=js"
export * from "./SocialWall.vue?vue&type=script&lang=js"
import style0 from "./SocialWall.vue?vue&type=style&index=0&id=351c9539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c9539",
  null
  
)

export default component.exports